import React, { useRef } from 'react';
import styles from './CustomFileInput.module.css';
import Button from './Button';

interface CustomFileInputProps {
  id: string;
  name: string;
  accept?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  value?: File | null; // Optional controlled value
}

const CustomFileInput: React.FC<CustomFileInputProps> = ({
  id,
  name,
  accept,
  onChange,
  disabled = false,
  className = '',
  value,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = React.useState<string>('');

  // Sync internal state with controlled value prop
  React.useEffect(() => {
    if (value === null || value === undefined) {
      setFileName('');
      // Also clear the actual input element
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } else if (value) {
      setFileName(value.name);
    }
  }, [value]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);
    } else {
      setFileName('');
    }
    onChange(e);
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className={`${styles.customFileInputContainer} ${className}`}>
      <input
        ref={fileInputRef}
        type="file"
        id={id}
        name={name}
        accept={accept}
        onChange={handleFileChange}
        disabled={disabled}
        className={styles.hiddenInput}
      />
      <Button
        type="button"
        onClick={handleButtonClick}
        disabled={disabled}
        size='small'
      >
        Choose File
      </Button>
      <span className={styles.fileName}>
        {fileName || 'No file chosen'}
      </span>
    </div>
  );
};

export default CustomFileInput;
